import { useCallback, useEffect, useRef, useState } from 'react';
const toError = (value) => (value instanceof Error ? value : new Error(String(value)));
const releasePermissionStatus = (statusRef, next) => {
    const previous = statusRef.current;
    if (previous === null || previous === next)
        return;
    previous.onchange = null;
};
const useGeolocationPermission = ({ errorReporter, setGeolocationStatus, setIsGettingLocation }) => {
    const permissionStatusRef = useRef(null);
    const [isPermissionsApiSupported, setIsPermissionsApiSupported] = useState(true);
    useEffect(() => () => {
        if (permissionStatusRef.current) {
            permissionStatusRef.current.onchange = null;
            permissionStatusRef.current = null;
        }
    }, []);
    const getGeolocationStatus = useCallback(async () => {
        if (!navigator?.permissions?.query) {
            setIsPermissionsApiSupported(false);
            setGeolocationStatus('prompt');
            return 'prompt';
        }
        setIsGettingLocation(true);
        let state = 'prompt';
        try {
            const result = await navigator.permissions.query({ name: 'geolocation' });
            state = result.state;
            releasePermissionStatus(permissionStatusRef, result);
            permissionStatusRef.current = result;
            result.onchange = () => {
                setGeolocationStatus(result.state);
            };
            setIsPermissionsApiSupported(true);
        }
        catch (error) {
            errorReporter.warning(toError(error));
            setIsPermissionsApiSupported(false);
            state = 'prompt';
        }
        setGeolocationStatus(state);
        setIsGettingLocation(false);
        return state;
    }, [errorReporter, setGeolocationStatus, setIsGettingLocation]);
    return { getGeolocationStatus, isPermissionsApiSupported };
};
export default useGeolocationPermission;
